import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import { MakeAccordian } from "./MakeAccordion";
/**
 * Displays Accordian with JSON view or editable text field
 */
export function JSONDisplay({ name, value, onChange, error, }) {
    return (_jsx(MakeAccordian, { name: name, details: _jsx(TextField, { label: name, value: value, onChange: onChange, disabled: onChange == null, error: error, multiline: true, fullWidth: true, variant: "outlined" }) }));
}
